'use strict';
const _ = require('lodash');

function runScript(devConsole, appId, script, moduleFunc, storage, routerData, sdk) {
  if (devConsole.info) {
    devConsole.info(`Loading the code for the ${script.displayName}. To debug this code, open ${script.scriptName} in Developer Tools.`);
  }
  if (_.isFunction(sdk.__INTERNAL__.addAppStudioGlobalsIfNeeded)) {
    sdk.__INTERNAL__.addAppStudioGlobalsIfNeeded(script.id);
  }
  self.$w = sdk.getSelector(script.id, script.displayName);
  self.routerReturnedData = routerData;
  self['wix-storage'] = sdk.getStorage(appId, storage);

  let module;
  try {
    module = moduleFunc && moduleFunc();
  } catch (e) {
    devConsole.error('There was an error in your script');
    devConsole.error(e);
  }

  delete self.$w;
  delete self.routerReturnedData;
  delete self['wix-storage'];

  return module;
}

module.exports = {
  runScript
};
